import SitecoreTextModel from '@models/SitecoreTextModel';

const TEXT_ARR = ['Description', 'Section Title', 'Added On Text'];

export default class CustomerWishlistPageModel {
  constructor() {
    TEXT_ARR.forEach((item) => {
      this[item] = new SitecoreTextModel();
    });
  }

  getData(dataSource) {
    TEXT_ARR.forEach((item) => {
      if (dataSource && Object.prototype.hasOwnProperty.call(dataSource, item)) {
        this[item].getData(dataSource[item]);
      }
    });

    return this;
  }
}
